import { ObligationRulesCategory, ObligationRulesFrequency } from '@commenda/prisma';
import { fetcher } from '@commenda/utils';
import { useQuery } from '@tanstack/react-query';

// One filing type Commenda supports for the entity. Date-less by design — the due date is fetched
// separately once a filing is picked (see getFilingDueDate), and derived server-side on create.
export interface SupportedFiling {
  compositeId: string;
  title: string;
  category: ObligationRulesCategory;
  frequency: ObligationRulesFrequency;
  requiresManualDueDate: boolean;
}

const getSupportedFilings = async (
  corporationId: number
): Promise<SupportedFiling[]> => {
  const res = await fetcher(
    `compliance/supported-filings?corporationId=${corporationId}`,
    { method: 'GET' }
  );
  if (!res.ok) throw new Error('Failed to fetch supported filings');
  return (await res.json()) as SupportedFiling[];
};

export const useSupportedFilings = (corporationId: number | undefined) =>
  useQuery({
    queryKey: ['supported-filings', corporationId],
    queryFn: () => getSupportedFilings(corporationId as number),
    enabled: !!corporationId,
  });
